(function () {
  if (window.__ES_BLOG_TRACKING__) return;
  window.__ES_BLOG_TRACKING__ = true;

  function track(eventName, payload) {
    var data = payload || {};
    data.event = eventName;

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
    } catch (e) {}

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, data);
      }
    } catch (e) {}
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target && event.target.closest ? event.target.closest('[data-es-track]') : null;
      if (!target) return;

      var eventName = target.getAttribute('data-es-track');
      if (!eventName) return;

      track(eventName, {
        location: target.getAttribute('data-es-track-location') || '',
        href: target.getAttribute('href') || '',
        page_path: window.location.pathname
      });
    },
    true
  );
})();
